import { useState } from 'react';
import { doc, setDoc } from 'firebase/firestore';
import { db } from '../firebase';
import './Login.css'; // Reuse login styles

export default function CompleteProfile({ user, onProfileComplete }) {
    const [name, setName] = useState(user?.displayName || '');
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');

    const handleSaveProfile = async (e) => {
        e.preventDefault();
        setError('');
        setIsLoading(true);

        try {
            await setDoc(doc(db, 'users', user.uid), {
                name: name,
                email: user.email || '',
                createdAt: new Date()
            });

            onProfileComplete();
        } catch (err) {
            console.error(err);
            setError('Failed to save profile.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="login-container">
            <h1>Almost there!</h1>
            <form onSubmit={handleSaveProfile} className="login-form">
                <p>Please enter your name so your friends know who you are.</p>
                <input
                    type="text"
                    placeholder="Your Name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                    autoFocus
                />
                <button type="submit" disabled={isLoading}>
                    {isLoading ? 'Saving...' : 'Get Started'}
                </button>
                {error && <p className="error">{error}</p>}
            </form>
        </div>
    );
}
